import React from 'react';

import ButtonBase from '../Button/ButtonBase';
import Icon from '../Icon/Icon';
import { TIconButton } from './types';

type TIconButtonBase = TIconButton & {
  kind: 'primary' | 'secondary' | 'tertiary' | 'destructive' | 'destructive-ghost' | 'action-image';
};

const IconButtonBase = ({ name, color, ariaLabel, ...rest }: TIconButtonBase) => (
  <ButtonBase {...rest} aria-label={ariaLabel || name} additionalModifiers={['icon-button']}>
    <Icon name={name} color={color} />
  </ButtonBase>
);

export default IconButtonBase;
